<template>
  <v-container id="messages" fluid class="private-background fill-height">

    <Nav></Nav>

    <v-main >

      <v-card
          :class="this.$vuetify.breakpoint.mdAndUp ? 'mx-auto profiles-background mb-16 overflow-hidden mt-5 pt-0 fill-height' : 'mx-auto profiles-background mb-16 overflow-hidden pt-0 fill-height' "
          max-width="1080"
          :max-height="windowHeight"
          v-if="loader === false"
      >
        <v-row
            align="start"
            class="fill-height pa-0 ma-0"
        >

          <v-col v-if="(this.$vuetify.breakpoint.mdAndUp || (step === 0 && this.$vuetify.breakpoint.smAndDown))" cols="12" xl="4" lg="4" md="4" class="pa-0 fill-height">
            <v-card
                class="mx-auto scroll-y overflow-y-auto fill-height rounded-r-0 pa-0 pb-0"
                max-height="100%"
            >

              <v-toolbar
                  color="blue-grey lighten-2"
                  dark

              >
                <v-app-bar-nav-icon @click="desarrollo"></v-app-bar-nav-icon>

                <v-toolbar-title class="black--text">Mensajes</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="desarrollo">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-toolbar>

              <v-list subheader fluid class="overflow-y-auto">

                <template v-for="(contact, j) in contacts">

                  <v-list-item @click="loadMessagesByContact(contact.sessionId, j)" link :key="contact.username">

                    <v-list-item-avatar>
                      <v-img
                          :alt="`${contact.username} avatar`"
                          :src="getCdn() + contact.folder + '/' + contact.image"
                      ></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="black--text" v-text="'@' + contact.username"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon>

                      <v-badge
                          color="green"
                          :content="contact.newMessages > 9 ? '9+' : contact.newMessages"
                          v-if="contact.newMessages > 0"
                          :class="contact.newMessages > 9 ? 'mr-2' : ''"
                      >
                        <v-icon :color="contact.newMessages > 0 ? 'deep-purple accent-4' : 'grey'">
                          mdi-message-outline
                        </v-icon>
                      </v-badge>

                      <v-icon v-else :color="contact.newMessages > 0 ? 'deep-purple accent-4' : 'grey'">
                        mdi-message-outline
                      </v-icon>

                    </v-list-item-icon>

                  </v-list-item>

                  <hr role="separator" aria-orientation="horizontal" class="v-divider theme--light" :key="contact.profileId" />

                </template>
              </v-list>

            </v-card>
          </v-col>

          <v-col cols="12" xl="8" v-if="positionSelected !== null && (this.$vuetify.breakpoint.mdAndUp || (step === 1 && this.$vuetify.breakpoint.smAndDown))" lg="8" md="8" class="pa-0 fill-height">
            <v-responsive
                class="overflow-y-hidden fill-height"
                height="100%"
                style="position: relative"
            >
              <v-toolbar
                  class="toolbar-loaded-messages"
                  color="blue-grey lighten-3"
                  dark
              >
                <v-toolbar-title class="black--text">@{{contacts[positionSelected].username}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon class="hidden-md-and-up" @click="goBack">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card
                  max-height="100%"
                  class="mx-auto d-flex flex-column fill-height rounded-0 pt-16"
                  color="blue-grey lighten-5"
              >

                <v-card-text id="container-messages" class="flex-grow-1 overflow-y-auto">
                  <template v-for="msg in messages">

                    <div
                        :class="{ 'd-flex flex-row-reverse': msg.isMyMessage === true }"
                        :key="msg.messageId"
                    >
                      <v-menu >
                        <template v-slot:activator="{ on }">
                          <v-hover
                              v-slot:default="{ hover }"
                          >
                            <v-chip
                                :color="msg.isMyMessage === true ? 'grey lighten-2' : 'blue-grey lighten-3'"
                                style="height:auto;white-space: normal;word-break: break-all;max-width:90%;position: relative"
                                class="py-2 px-4 mb-2 black--text chip-messages rounded-lg"
                                v-on="on"
                                text-color="black"
                            >
                              {{ msg.message }}
                              <sub
                                  class="ml-2 black--text"
                                  style="font-size: 0.6rem;width:28px !important;position:absolute;bottom:6px;right:2px;"
                              >{{ msg.messageTime }}</sub>
                              <v-icon
                                  v-if="hover"
                                  small
                                  color="black"
                                  style="position:absolute;top:6px;right:2px;"
                              >
                                mdi-arrow-down
                              </v-icon>
                            </v-chip>
                          </v-hover>
                        </template>

                        <v-row cols="12" style="background-color: white;overflow-y: hidden" class="pa-5">
                          <v-col cols="12" class="flex" style="overflow: hidden">
                            <div class="col-6 float-left pa-2">
                              <v-btn icon @click="desarrollo">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </div>

                            <div class="col-6 float-left pa-2">
                              <v-btn icon @click="desarrollo">
                                <v-icon>mdi-reply</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>

                      </v-menu>
                    </div>

                  </template>
                </v-card-text>
                <v-card-text class="flex-shrink-1">
                  <v-textarea
                      class="input-messages"
                      v-model="message"
                      label="Escribe un mensaje"
                      type="text"
                      no-details
                      outlined
                      auto-grow
                      rows="1"
                      append-outer-icon="mdi-send"
                      @keyup.enter="send(positionSelected)"
                      @click:append-outer="send(positionSelected)"
                      hide-details
                  />
                </v-card-text>

              </v-card>
            </v-responsive>
          </v-col>
        </v-row>
      </v-card>

      <v-card
          class="mx-auto profiles-background pt-16"
          style="display:flex;justify-content: center"
          height="100%"
          max-width="1080"
          v-if="loader === true && error === false"
      >
        <fingerprint-spinner
            :animation-duration="3000"
            :size="64"
            color="rgb(194, 194, 194)"
        />
      </v-card>

      <v-card
          class="mx-auto profiles-background"
          style="display:flex;justify-content: center"
          height="100%"
          max-width="1080"
          v-if="error === true"
      >
        <v-card-title color="white">{{$t('profile.errors.loading_profile')}}</v-card-title>

      </v-card>

    </v-main>
  </v-container>
</template>

<script>
import Nav from "@/components/Nav"
import Messages from "@/services/Messages";
import Environment from "@/services/Environment";
import "../css/private.css";

import {FingerprintSpinner} from "epic-spinners";
import store from "../store";


export default {
  data: () => ({
    error: false,
    step: 0,
    windowHeight: window.innerHeight - 120,
    loader: false,
    positionSelected: null,
    show: true,
    message: '',
    contacts: [],
    messages: [],
    lastMessageId: null,
    sessionIdSelected: null,
    intervalId: null
  }),

  methods: {
    Environment() {
      return Environment
    },
    onResize() {
      this.windowHeight = window.innerHeight
    },
    loadMessagesByContact(sessionId, positionSelected){
      Messages.loadMessagesByContact(this.$store.state.tokenStored, sessionId).then((response)=> {
        if (!response || response.success === false) {
          return
        }

        this.step = 1
        this.positionSelected = positionSelected
        this.sessionIdSelected = sessionId
        this.messages = response.messages
        this.lastMessageId = response.lastMessageId
        let obj = this
        let contactSelected = this.contacts[positionSelected]

        setTimeout(function(){
          obj.messagesScrollDown()
          obj.markMessagesAsViewed(contactSelected, sessionId)
        }, 50);

        this.intervalId = setInterval(function(){
          obj.getNewMessages()
        }, 10000);
      })
    },
    markMessagesAsViewed(contactSelected, sessionId){
      Messages.markMessagesAsViewed(this.$store.state.tokenStored, sessionId).then((response)=> {
        if (!response || response.success === false) {
          return
        }

        contactSelected.newMessages = 0
      })
    },
    send(positionSelected){
      if (this.message === '') {
        return
      }

      Messages.send(store.state.tokenStored, this.contacts[positionSelected].profileId, this.message).then((response)=> {

        if (!response || !response.success || response.success === false) {
          alert('Ha habido un error:' + JSON.stringify(response))
          return
        }

        const now = new Date();
        const current = now.getHours() + ':' + now.getMinutes();

        this.messages.push({
          'messageId': response.messageId,
          'profileId': this.contacts[positionSelected].profileId,
          'username': this.contacts[positionSelected].username,
          'messageTime': current,
          'viewed': true,
          'message': this.message,
          'isMyMessage': true
        })

        this.lastMessageId = response.messageId
        this.moveContactToTheTop(positionSelected)
        let obj = this
        this.message = ''

        setTimeout(function(){
          obj.messagesScrollDown()
        }, 50);

      })
    },
    getNewMessages(){
      if (this.step === 0) {
        return
      }
      Messages.getNewMessages(store.state.tokenStored, this.sessionIdSelected, this.lastMessageId).then((response)=> {
        if (!response || !response.success || response.success === false) {
          alert('Ha habido un error:' + JSON.stringify(response))
          return
        }

        if (response.messages.length > 0) {
          for(let m in response.messages){
            this.messages.push(response.messages[m])
          }
          this.lastMessageId = response.lastMessageId
        }
      })
    },
    moveContactToTheTop(positionSelected){
      const element = this.contacts.splice(positionSelected, 1)[0];
      this.contacts.splice(0, 0, element);
    },
    messagesScrollDown(){
      this.elem = document.getElementById ( "container-messages" ).lastElementChild
      this.container = document.getElementById ( "container-messages" )
      this.container.scrollTop = Math.floor ( this.elem.offsetTop + this.elem.offsetHeight + 250)
    },
    goBack(){
      this.step = 0
      this.lastMessageId = 0
      this.sessionIdSelected = null
      window.clearInterval(this.intervalId);
    },
    desarrollo(){
      alert('Funcionalidad en desarrollo')
    },
    getCdn(){
      return Environment.getCdn()
    }
  },
  created (){
    Messages.readContacts(this.$store.state.tokenStored).then((response)=> {
      this.loader = false

      if (!response || response.success === false) {
        return
      }

      this.contacts = response.contacts
    }).catch((error)=> {
      this.error = true
    }).finally(()=> {
      this.loader = false
    })
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.onResize);
    window.clearInterval(this.intervalId);
  },
  components: { Nav}
}
</script>
<style type="text/css">
#messages{
  height:100%;
  overflow: hidden;
}
.chip-messages > *{
  color:black !important;
}
.toolbar-loaded-messages{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  z-index:4
}
.input-messages {
  max-height: 115px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>